(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["install-methods"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('install-methods')) {
    customElements.define('install-methods', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const select = (index) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', i === index);
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index));
          tab.addEventListener('keydown', (event) => {
            const next = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
            if (next === undefined) return;
            event.preventDefault();
            select(next);
            tabs[next].focus();
          });
        });
        this.addEventListener('shopify:block:select', (event) => {
          const index = panels.indexOf(event.target.closest('[role="tabpanel"]'));
          if (index !== -1) select(index);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stylist-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-ywigs-stylist-directory]';
  const instances = new WeakMap();

  function initialize(directory) {
    if (instances.has(directory)) return;

    const lifecycle = new AbortController();
    instances.set(directory, lifecycle);
    const stateSelect = directory.querySelector('[data-state-filter]');
    const citySelect = directory.querySelector('[data-city-filter]');
    const grid = directory.querySelector('[data-stylist-grid]');
    const count = directory.querySelector('[data-result-count]');
    const emptyMessage = directory.querySelector('[data-empty-message]');
    const pagination = directory.querySelector('[data-pagination]');
    const status = directory.querySelector('[data-load-status]');
    const statusText = directory.querySelector('[data-load-message]');
    const retry = directory.querySelector('[data-load-retry]');
    const pageSize = 24;
    const initialPage = Number(directory.dataset.currentPage);
    const pageParam = directory.dataset.pageParam;
    const sectionId = directory.dataset.sectionId;
    const baseUrl = new URL(window.location.href);
    const cardMap = new Map();
    let cards = [];
    let currentPage = 1;
    let loading = false;
    let complete = directory.dataset.directoryComplete === 'true';
    let nextUrl = directory.dataset.nextUrl || '';
    let expectedPage = initialPage === 1 ? 2 : 1;
    const visited = new Set(initialPage === 1 ? [1] : []);

    if (initialPage !== 1) {
      const firstUrl = new URL(baseUrl);
      firstUrl.searchParams.set(pageParam, '1');
      nextUrl = firstUrl.href;
    }

    directory.querySelectorAll('[data-stylist-card]').forEach(card => {
      cardMap.set(card.dataset.stylistId, card);
    });

    function rebuildCards() {
      cards = [...cardMap.values()].sort((a, b) => {
        const left = a.dataset.stylistHandle || '';
        const right = b.dataset.stylistHandle || '';
        return left < right ? -1 : left > right ? 1 : 0;
      });
      const fragment = document.createDocumentFragment();
      cards.forEach(card => fragment.appendChild(card));
      grid.appendChild(fragment);
    }

    const uniqueValues = values => [...new Set(values.filter(Boolean))].sort();

    function addOptions(select, values, defaultText, selectedValue = '') {
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = defaultText;
      select.replaceChildren(placeholder);
      values.forEach(value => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      select.value = values.includes(selectedValue) ? selectedValue : '';
    }

    function updateCityOptions(preserveSelection = false) {
      const selectedCity = preserveSelection ? citySelect.value : '';
      const selectedState = stateSelect.value;
      const cities = uniqueValues(
        cards.filter(card => !selectedState || card.dataset.state === selectedState)
          .map(card => card.dataset.city)
      );
      addOptions(citySelect, cities, directory.dataset.allCities, selectedCity);
    }

    function refreshOptions() {
      addOptions(
        stateSelect,
        uniqueValues(cards.map(card => card.dataset.state)),
        directory.dataset.allStates,
        stateSelect.value
      );
      updateCityOptions(true);
    }

    function getFilteredCards() {
      return cards.filter(card =>
        (!stateSelect.value || card.dataset.state === stateSelect.value) &&
        (!citySelect.value || card.dataset.city === citySelect.value)
      );
    }

    function createPageButton(page, label, disabled, isCurrent, accessibleLabel) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.page = String(page);
      button.textContent = String(label);
      button.disabled = disabled;
      if (isCurrent) button.setAttribute('aria-current', 'page');
      if (accessibleLabel) button.setAttribute('aria-label', accessibleLabel);
      return button;
    }

    function renderPagination(totalPages) {
      pagination.replaceChildren();
      pagination.hidden = totalPages <= 1;
      if (totalPages <= 1) return;
      pagination.appendChild(createPageButton(
        currentPage - 1, '←', currentPage === 1, false, directory.dataset.previousLabel
      ));
      for (let page = 1; page <= totalPages; page += 1) {
        pagination.appendChild(createPageButton(page, page, false, page === currentPage));
      }
      pagination.appendChild(createPageButton(
        currentPage + 1, '→', currentPage === totalPages, false, directory.dataset.nextLabel
      ));
    }

    function filterCards() {
      const filteredCards = getFilteredCards();
      const totalPages = Math.max(1, Math.ceil(filteredCards.length / pageSize));
      currentPage = Math.min(currentPage, totalPages);
      const start = (currentPage - 1) * pageSize;
      cards.forEach(card => { card.hidden = true; });
      filteredCards.slice(start, start + pageSize).forEach(card => { card.hidden = false; });
      const template = !complete ? directory.dataset.countPartial
        : filteredCards.length === 1 ? directory.dataset.countOne : directory.dataset.countMany;
      count.textContent = template.replace('__COUNT__', String(filteredCards.length));
      emptyMessage.hidden = !complete || filteredCards.length !== 0;
      renderPagination(totalPages);
    }

    function renderLoadState() {
      stateSelect.disabled = !complete;
      citySelect.disabled = !complete;
      status.hidden = complete;
      statusText.textContent = loading ? directory.dataset.loadingText : directory.dataset.errorText;
      retry.hidden = loading || complete;
      retry.disabled = loading;
      grid.setAttribute('aria-busy', String(loading));
      filterCards();
    }

    function requestUrl(value) {
      const url = new URL(value, baseUrl);
      if (url.origin !== baseUrl.origin || url.pathname !== baseUrl.pathname) {
        throw new Error('Unexpected directory URL');
      }
      baseUrl.searchParams.forEach((value, key) => {
        if (key !== 'section_id' && key !== 'sections' && !url.searchParams.has(key)) {
          url.searchParams.set(key, value);
        }
      });
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', sectionId);
      url.hash = '';
      return url;
    }

    async function fetchPage(url) {
      const request = new AbortController();
      const cancel = () => request.abort();
      lifecycle.signal.addEventListener('abort', cancel, { once: true });
      const timeout = setTimeout(cancel, 20000);
      try {
        const response = await fetch(url.href, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: request.signal
        });
        if (!response.ok) throw new Error('Directory request failed');
        const html = await response.text();
        return new DOMParser().parseFromString(html, 'text/html').getElementById(directory.id);
      } finally {
        clearTimeout(timeout);
        lifecycle.signal.removeEventListener('abort', cancel);
      }
    }

    async function loadAll() {
      if (loading || complete || lifecycle.signal.aborted) return;
      loading = true;
      renderLoadState();
      try {
        if (!pageParam || !sectionId || !Number.isInteger(initialPage) || initialPage < 1) {
          throw new Error('Invalid directory pagination');
        }
        if (!nextUrl && Number(directory.dataset.totalPages) > initialPage) {
          throw new Error('Missing next directory page');
        }
        while (nextUrl) {
          const url = requestUrl(nextUrl);
          if (Number(url.searchParams.get(pageParam)) !== expectedPage || visited.has(expectedPage)) {
            throw new Error('Directory pagination did not advance');
          }
          const incoming = await fetchPage(url);
          if (lifecycle.signal.aborted || !directory.isConnected) return;
          if (!incoming || !incoming.matches(selector) ||
              incoming.dataset.sectionId !== sectionId ||
              incoming.dataset.pageParam !== pageParam ||
              Number(incoming.dataset.currentPage) !== expectedPage) {
            throw new Error('Invalid directory response');
          }
          const totalPages = Number(incoming.dataset.totalPages);
          const followingUrl = incoming.dataset.nextUrl || '';
          if (!Number.isInteger(totalPages) || totalPages < expectedPage ||
              Boolean(followingUrl) !== (expectedPage < totalPages)) {
            throw new Error('Incomplete directory response');
          }
          const incomingGrid = incoming.querySelector('[data-stylist-grid]');
          if (!incomingGrid) throw new Error('Missing directory grid');
          const incomingCards = [...incomingGrid.querySelectorAll('[data-stylist-card]')];
          if (!incomingCards.length) throw new Error('Empty directory page');
          const keys = incomingCards.map(card => card.dataset.stylistId);
          if (keys.some(key => !key) || new Set(keys).size !== keys.length) {
            throw new Error('Invalid stylist identifiers');
          }
          if (incomingCards.length && keys.every(key => cardMap.has(key)) && expectedPage !== initialPage) {
            throw new Error('Repeated directory records');
          }
          incomingCards.forEach(card => {
            if (!cardMap.has(card.dataset.stylistId)) {
              card.hidden = true;
              cardMap.set(card.dataset.stylistId, card);
            }
          });
          visited.add(expectedPage);
          nextUrl = followingUrl;
          expectedPage += 1;
          rebuildCards();
          refreshOptions();
          filterCards();
        }
        complete = true;
        directory.dataset.directoryComplete = 'true';
      } catch (error) {
        if (lifecycle.signal.aborted || !directory.isConnected) return;
        complete = false;
      } finally {
        loading = false;
        if (!lifecycle.signal.aborted && directory.isConnected) renderLoadState();
      }
    }

    const eventOptions = { signal: lifecycle.signal };
    stateSelect.addEventListener('change', () => {
      currentPage = 1;
      updateCityOptions();
      filterCards();
    }, eventOptions);
    citySelect.addEventListener('change', () => {
      currentPage = 1;
      filterCards();
    }, eventOptions);
    pagination.addEventListener('click', event => {
      const button = event.target.closest('[data-page]');
      if (!button || button.disabled || !pagination.contains(button)) return;
      currentPage = Number(button.dataset.page);
      filterCards();
      directory.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, eventOptions);
    retry.addEventListener('click', loadAll, eventOptions);

    rebuildCards();
    refreshOptions();
    renderLoadState();
    if (!complete) loadAll();
  }

  function directoriesWithin(root) {
    const directories = [...root.querySelectorAll(selector)];
    if (root.matches && root.matches(selector)) directories.unshift(root);
    return directories;
  }

  function initializeWithin(root) {
    directoriesWithin(root).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    directoriesWithin(event.target).forEach(directory => {
      const lifecycle = instances.get(directory);
      if (lifecycle) lifecycle.abort();
      instances.delete(directory);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yw-stylist-profile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('yw-stylist-profile')) return;
    class YWStylistProfile extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.frames = new Map();
        this.tabs = [...this.querySelectorAll('[data-yws-tab]')];
        this.panels = [...this.querySelectorAll('[data-yws-panel]')];
        this.work = this.querySelector('[data-yws-work]');
        if (!this.work || !this.tabs.length) return;
        this.inView = false;
        this.classList.add('yws-enhanced');
        this.querySelector('[data-yws-tabs]').hidden = false;
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.ywsTab === panel.dataset.ywsPanel).id);
        });
        const options = {signal:this.controller.signal};
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-yws-tab]');
          if (tab && this.contains(tab)) this.activate(tab.dataset.ywsTab);
          const retry = event.target.closest('[data-yws-retry]');
          if (retry && this.contains(retry)) {
            const container = retry.closest('[data-yws-embed]');
            const entry = this.frames.get(container);
            if (entry) { clearTimeout(entry.timer); entry.frame.remove(); this.frames.delete(container); }
            this.loadActive();
          }
        }, options);
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-yws-tab]');
          if (!tab || !this.tabs.includes(tab) || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.tabs.indexOf(tab);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.activate(this.tabs[next].dataset.ywsTab);
          this.tabs[next].focus();
        }, options);
        window.addEventListener('message', event => this.receive(event), options);
        this.activate(this.dataset.defaultPlatform);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.inView = true;
            this.observer.disconnect();
            this.loadActive();
          }, {rootMargin:'160px'});
          this.observer.observe(this.work);
        } else { this.inView = true; this.loadActive(); }
      }
      activate(platform) {
        if (!this.tabs.some(tab => tab.dataset.ywsTab === platform)) platform = this.tabs[0].dataset.ywsTab;
        this.activePlatform = platform;
        this.tabs.forEach(tab => {
          const selected = tab.dataset.ywsTab === platform;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => {panel.hidden = panel.dataset.ywsPanel !== platform;});
        this.loadActive();
      }
      loadActive() {
        if (!this.inView) return;
        const panel = this.panels.find(item => item.dataset.ywsPanel === this.activePlatform);
        const container = panel?.querySelector('[data-yws-embed]');
        if (!container) return;
        const existing = this.frames.get(container);
        if (existing) {
          if (existing.lastHeight) this.applyHeight(existing, existing.lastHeight);
          existing.frame.contentWindow?.postMessage({kind:'yw-stylist-measure',nonce:existing.nonce}, '*');
          return;
        }
        const template = container.querySelector('[data-yws-template]');
        if (!template) return;
        const frame = document.createElement('iframe');
        frame.className = 'yws-frame';
        frame.style.cssText = 'width:100%;max-width:100%;min-width:0;border:0';
        frame.setAttribute('width', String(Math.round(container.getBoundingClientRect().width)));
        frame.title = `${this.activePlatform === 'instagram' ? 'Instagram' : 'TikTok'} creator profile`;
        frame.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
        frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        // 固定官方模板；不接收任何自定义 HTML。各平台 SDK 在独立文档内只运行一次。
        const nonce = Array.from(crypto.getRandomValues(new Uint32Array(4)), n => n.toString(16)).join('-');
        const sdk = this.activePlatform === 'instagram' ? 'https://www.instagram.com/embed.js' : 'https://www.tiktok.com/embed.js';
        const bridge = `(function ${this.embedBridge.toString()})(${JSON.stringify(nonce)},${JSON.stringify(sdk)})`;
        frame.srcdoc = '<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style>html,body{margin:0;padding:0;background:transparent;overflow:hidden}#stage{transform-origin:top left;display:flow-root}#stage blockquote,#stage iframe{display:block!important;box-sizing:border-box!important;width:100%!important;min-width:0!important;max-width:100%!important;margin:0!important}a{color:#665644}</style></head><body><div id="stage">' + template.innerHTML + '</div><script>' + bridge + '<' + '/script></body></html>';
        const entry = {frame,nonce,container,timer:null,lastHeight:0};
        this.frames.set(container, entry);
        container.append(frame);
        container.querySelector('[data-yws-status]').hidden = false;
        container.querySelector('[data-yws-fallback]').hidden = true;
        entry.timer = setTimeout(() => {
          if (!frame.isConnected) return;
          container.querySelector('[data-yws-status]').hidden = true;
          container.querySelector('[data-yws-fallback]').hidden = false;
        }, 20000);
      }
      embedBridge(nonce, sdk) {
        const stage = document.getElementById('stage');
        const send = data => parent.postMessage({kind:'yw-stylist-embed',nonce,...data}, '*');
        const isTikTok = sdk === 'https://www.tiktok.com/embed.js';
        let tikTokHeight = 0;
        let scheduled = false;
        function measure() {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(() => {
            scheduled = false;
            const width = window.innerWidth;
            if (!width) return;
            // 官方 Instagram 预览有最小宽度；小屏整体等比适配，避免水平裁切。
            const naturalWidth = Math.max(328, width);
            const scale = width / naturalWidth;
            if (stage.style.width !== `${naturalWidth}px`) stage.style.width = `${naturalWidth}px`;
            if (stage.style.transform !== `scale(${scale})`) stage.style.transform = `scale(${scale})`;
            if (isTikTok) {
              const nativeFrame = stage.querySelector('iframe');
              if (nativeFrame) {
                // SDK 的 load 回调可能把已测量的像素高度重设为 100%。
                // 保留平台返回的高度；尚未返回时给作品区可用的初始高度。
                const inlineHeight = nativeFrame.style.height;
                const pixels = inlineHeight.endsWith('px') ? Number.parseFloat(inlineHeight) : 0;
                const height = tikTokHeight || (pixels > 50 && pixels <= 12000 ? pixels : 520);
                if (nativeFrame.style.height !== `${height}px`) nativeFrame.style.height = `${height}px`;
                if (nativeFrame.style.maxHeight) nativeFrame.style.maxHeight = '';
              }
            }
            const height = Math.ceil(stage.getBoundingClientRect().height);
            // 初始 iframe 尺寸不是加载成功信号；等 TikTok 返回高度后再解除超时提示。
            if (stage.querySelector('iframe') && height > 50 && (!isTikTok || tikTokHeight > 0)) send({height});
          });
        }
        new ResizeObserver(measure).observe(stage);
        new MutationObserver(measure).observe(stage, {childList:true,subtree:true,attributes:true,attributeFilter:['style','height','width']});
        window.addEventListener('resize', measure);
        window.addEventListener('message', event => {
          if (event.source === parent && event.data?.kind === 'yw-stylist-measure' && event.data.nonce === nonce) measure();
          if (!isTikTok || event.origin !== 'https://www.tiktok.com') return;
          const nativeFrame = stage.querySelector('iframe');
          if (!nativeFrame || event.source !== nativeFrame.contentWindow) return;
          let data = event.data;
          if (typeof data === 'string') { try { data = JSON.parse(data); } catch (_) { return; } }
          if (!data || data.signalSource !== nativeFrame.name) return;
          // 官方卡片部分链接通过 postMessage 打开；仅接受当前 TikTok iframe 的官方链接。
          if (typeof data.link === 'string') {
            try {
              const link = new URL(data.link);
              if (link.protocol === 'https:' && !link.username && !link.password && !link.port &&
                  (link.hostname === 'www.tiktok.com' || link.hostname === 'tiktok.com')) {
                window.open(link.href, '_blank', 'noopener,noreferrer');
              }
            } catch (_) { /* Ignore invalid links. */ }
          }
          const height = Number(data.height);
          if (!Number.isFinite(height) || height <= 50 || height > 12000) return;
          tikTokHeight = Math.ceil(height);
          measure();
        });
        stage.addEventListener('load', measure, true);
        stage.style.width = `${Math.max(328, window.innerWidth)}px`;
        if (isTikTok) {
          const handle = stage.querySelector('blockquote[data-unique-id]')?.dataset.uniqueId;
          if (!handle || !/^[a-zA-Z0-9_.]+$/.test(handle)) { send({error:true}); return; }
          // 与 TikTok 官方 SDK 相同的 creator 端点；首次请求即使用英文，无二次重载。
          const nativeFrame = document.createElement('iframe');
          const url = new URL(`https://www.tiktok.com/embed/@${handle}`);
          url.searchParams.set('lang', 'en');
          if (document.referrer) url.searchParams.set('referrer', document.referrer);
          nativeFrame.name = `__tt_embed__${nonce}`;
          nativeFrame.title = 'TikTok creator profile';
          nativeFrame.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
          nativeFrame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
          nativeFrame.style.cssText = 'display:block;width:100%;height:520px;border:0';
          nativeFrame.src = url.href;
          stage.replaceChildren(nativeFrame);
          measure();
          return;
        }
        const script = document.createElement('script');
        script.async = true;
        script.src = sdk;
        script.onerror = () => send({error:true});
        script.onload = () => { if (window.instgrm?.Embeds?.process) window.instgrm.Embeds.process(); measure(); };
        document.body.append(script);
        measure();
      }
      receive(event) {
        const message = event.data;
        if (!message || message.kind !== 'yw-stylist-embed') return;
        for (const entry of this.frames.values()) {
          if (event.source !== entry.frame.contentWindow || message.nonce !== entry.nonce) continue;
          const status = entry.container.querySelector('[data-yws-status]');
          const fallback = entry.container.querySelector('[data-yws-fallback]');
          if (message.error) {
            clearTimeout(entry.timer); status.hidden = true; fallback.hidden = false; entry.frame.dataset.failed = 'true';
          } else if (Number.isFinite(message.height) && message.height > 50 && message.height <= 12000) {
            entry.lastHeight = message.height;
            if (entry.container.closest('[data-yws-panel]').hidden) return;
            this.applyHeight(entry, message.height);
            // 这只表示平台生成了嵌入框，不代表账号存在或作品已通过平台验证。
          }
          return;
        }
      }
      applyHeight(entry, height) {
        if (entry.frame.style.height !== `${height}px`) entry.frame.style.height = `${height}px`;
        entry.frame.dataset.visible = 'true';
        delete entry.frame.dataset.failed;
        entry.container.querySelector('[data-yws-status]').hidden = true;
        entry.container.querySelector('[data-yws-fallback]').hidden = true;
        clearTimeout(entry.timer);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.frames?.forEach(entry => {clearTimeout(entry.timer); entry.frame.remove();});
        this.frames?.clear();
        this.controller = null;
      }
    }
    customElements.define('yw-stylist-profile', YWStylistProfile);
  })();

  } catch(e) { console.error(e); }
})();
})();
